var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"timelineReview",staticStyle:{"margin-top":"47px"}},[_c('spinner',{attrs:{"data":_vm.spinnerData}}),_c('all-feeds',{attrs:{"feeds":_vm.feeds,"feed-status":_vm.feedsStatus,"feeds-count":_vm.fullFeedsCount}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }